import classNames from 'classnames';
import { ComponentProps, ReactNode, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

export type DropDownMenuOption = {
  text: ReactNode;
  icon?: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  link?: string;
};

type DropDownMenuOwnProps = {
  options: DropDownMenuOption[];
  onClick?: () => void;
  className?: string;
};
type DropDownMenuProps = DropDownMenuOwnProps &
  Omit<ComponentProps<'div'>, keyof DropDownMenuOwnProps>;

const DropDownMenu = ({
  options,
  onClick,
  className = '',
  onBlur,
  ...props
}: DropDownMenuProps) => {
  const [key] = useState(Math.random().toString(36).substring(7));
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        onBlur?.(event as any);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onBlur]);

  const getOptionClasses = (disabled: boolean) => classNames(
    'relative group hover:text-secondary-600 !rounded-none w-full enabled:hover:bg-secondary-50 text-sm py-1 px-3 flex gap-2 items-center active:bg-secondary-100 disabled:cursor-not-allowed disabled:text-secondary-300 hover:cursor-pointer',
    { 'hover:bg-secondary-50': disabled }
  )

  return (
    <div
      ref={dropdownRef}
      onBlur={onBlur}
      className={classNames(
        'absolute text-body-2-xl bg-bg w-64 py-2 -translate-x-[14.5rem] translate-y-[1px] rounded-lg shadow-down-md text-secondary-600',
        className
      )}
      {...props}
    >
      {options.map((option, index) => {
        if (option.link) {
          return (
            <Link
              key={`${key}${index}`}
              to={option.link}
              className={getOptionClasses(!option.disabled)}
            >
              {option.icon}
              {option.text}
            </Link>
          );
        }

        return (
          <div
            key={`${key}${index}`}
            onClick={() => {
              option.onClick?.();
              onClick?.();
            }}
            className={getOptionClasses(!option.disabled)}
          >
            {option.icon}
            {option.text}
          </div>
        );
      })}
    </div>
  );
};

export default DropDownMenu;
